import Vue from 'vue';
import Router from 'vue-router';
/* Layout */
import Layout from '@/layout/index.vue';
/* Router modules */
import adminRouter from './modules/admin';
import masterRouter from './modules/master';
import productRouter from './modules/product';
import orderRouter from './modules/order';
import accountManagementRouter from './modules/account-managment';
import settingRouter from './modules/setting';
import dealerRouter from './modules/dealers';
import schemeRouter from './modules/schemes';
import inventoryRouter from './modules/inventory';
import reportRouter from './modules/report';
Vue.use(Router);
/*
  Note: sub-menu only appear when children.length>=1
  Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
*/
/*
  name:'router-name'             the name field is required when using <keep-alive>, it should also match its component's name property
                                 detail see : https://vuejs.org/v2/guide/components-dynamic-async.html#keep-alive-with-Dynamic-Components
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    roles: ['superadmin','admin','executive']   will control the page roles (allow setting multiple roles)
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    hidden: true                 if true, this route will not show in the sidebar (default is false)
    alwaysShow: true             if true, will always show the root menu (default is false)
                                 if false, hide the root menu when has less or equal than one children route
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    noCache: true                if true, the page will not be cached (default is false)
    affix: true                  if true, the tag will affix in the tags-view
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
*/
/**
  ConstantRoutes
  a base page that does not have permission requirements
  all roles can be accessed
*/
export const constantRoutes = [{
  path: '/redirect',
  component: Layout,
  meta: {
    hidden: true
  },
  children: [{
    path: '/redirect/:path*',
    component: () => import(/* webpackChunkName: "redirect" */'@/views/redirect/index.vue')
  }]
}, {
  path: '/login',
  component: () => import(/* webpackChunkName: "login" */'@/views/login/index.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/agent-login',
  component: () => import(/* webpackChunkName: "login" */'@/views/login/agent.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/admin-login-otp',
  component: () => import(/* webpackChunkName: "login" */'@/views/login/admin-otp.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/admin-verify-otp',
  component: () => import(/* webpackChunkName: "login" */'@/views/login/verify-otp.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/account-delete',
  component: () => import(/* webpackChunkName: "login" */'@/views/login/delete-account.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/recover-password',
  component: () => import(/* webpackChunkName: "login" */'@/views/login/password-recovery.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/reset-password/:hash(.*)',
  component: () => import(/* webpackChunkName: "login" */'@/views/login/reset-password.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/auth-redirect',
  component: () => import(/* webpackChunkName: "auth-redirect" */'@/views/login/auth-redirect.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/404',
  component: () => import(/* webpackChunkName: "404" */'@/views/error-page/404.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/403',
  component: () => import(/* webpackChunkName: "404" */'@/views/error-page/403.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/401',
  component: () => import(/* webpackChunkName: "401" */'@/views/error-page/401.vue'),
  meta: {
    hidden: true
  }
}, {
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  meta: {
    title: 'Home',
    icon: 'building',
    alwaysShow: true
  },
  children: [{
    path: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */'@/views/dashboard/index.vue'),
    name: 'Dashboard',
    meta: {
      title: 'dashboard',
      icon: 'dashboard',
      affix: true
    }
  }, {
    path: 'analytics',
    component: () => import(/* webpackChunkName: "analytics" */'@/views/dashboard/admin/components/Analytics.vue'),
    name: 'Analytics',
    meta: {
      roles: ['Super Admin'],
      title: 'analytics',
      icon: 'chart',
      noCache: true,
      hidden: true
    }
  }]
}, {
  path: '/profile',
  component: Layout,
  redirect: '/profile/index',
  meta: {
    hidden: true
  },
  children: [{
    path: 'index',
    component: () => import(/* webpackChunkName: "profile" */'@/views/profile/index.vue'),
    name: 'Profile',
    meta: {
      title: 'profile',
      icon: 'user',
      noCache: true
    }
  }]
}];
/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [/** when your routing map is too long, you can split it into small modules **/
adminRouter, settingRouter, masterRouter, productRouter, dealerRouter, schemeRouter, orderRouter, accountManagementRouter, inventoryRouter, reportRouter,
// locationsRouter,
// notificationsRouter,
// usersRouter,
{
  path: '*',
  redirect: '/404',
  meta: {
    hidden: true
  }
}, {
  path: '403',
  redirect: '/403',
  meta: {
    hidden: true
  }
}];
const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
  base: process.env.BASE_URL,
  routes: constantRoutes
});
const router = createRouter();
// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;